// extracted by mini-css-extract-plugin
export default {"productGallery":"QL-z","inQuickShop":"RL-z"};